import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ButtonWrapper,
} from '../../components';

const ServerError = () => {
  const { t } = useTranslation();

  return (
    <div className="ServerError">
      <h1>{t('pages.500.title')}</h1>
      <span>{t('pages.500.body', { pagename: window.location.href })}</span>
      <div className="Buttonwrapper">
        <ButtonWrapper href={t('pages.500.primary_button.url')}>{t('pages.500.primary_button.link')}</ButtonWrapper>
        <ButtonWrapper type="secondary" href={t('pages.500.secondary_button.url')}>{t('pages.500.secondary_button.link')}</ButtonWrapper>
      </div>
    </div>
  );
};

export default ServerError;
